import { gql, useMutation } from '@apollo/client'
import type { GQL_ID } from '@@partner:types:graphql'

export interface DeleteCountryMutation {
  deleteCountry: boolean
}

export interface DeleteCountryVariables {
  id: GQL_ID
}

export const GQL_MUTATION_DELETE_COUNTRY = gql`
  mutation deleteCountry($id: ID!) {
    deleteCountry(id: $id)
  }
`

export const useDeleteCountry = () =>
  useMutation<DeleteCountryMutation, DeleteCountryVariables>(GQL_MUTATION_DELETE_COUNTRY)
